import { PayoutViewContainer } from './view/container';

export const PayoutViewRoute = PayoutViewContainer;
